import { CaseModel, Submission, SubmissionProcessingStatus } from 'type-declarations';

export const getActiveSubmissions = (theCase: CaseModel): Submission[] =>
	theCase.submissions.filter(
		(submission) =>
			submission.processingStatus !== SubmissionProcessingStatus.Ignored &&
			submission.processingStatus !== SubmissionProcessingStatus.Deleted
	);
